import React, { useState, useEffect } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton } from "../../components/btn/Buttons";
import SmallModal from "../../components/modal/SmallModal";
import { base_url, getFinancialYearOptions } from "../../utils/utils";
import { useSelector } from "react-redux";
import { get_balance_sheet_report } from "./finacialReportSlice";
import store from "../../redux/store";
import PageLoading from "../../components/PageLoading";
import Button from "../../components/btn/Button";
import Dropdown from "../../components/inputs/Dropdown";
import "./Balancesheet.css";
import moment from "moment";
import Input from "../../components/inputs/Input";
import axios from "axios";
import { toast } from "react-toastify";

const BalanceSheet = () => {
  const [alerts, setAlerts] = useState(false);
  const [alertsMess, setAlertsMess] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [balanceSheetData, setBalanceSheetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { profile_data } = useSelector((state) => state.profile);
  const { user_id } = useSelector((state) => state.other);

  const { balance_sheet_list, balance_sheet_loading } = useSelector(
    (state) => state.finacialReport
  );

  // Update local state when data is fetched
  useEffect(() => {
    if (balance_sheet_list?.length > 0 && financialYear) {
      setBalanceSheetData(balance_sheet_list[0]);
    }
  }, [balance_sheet_list, financialYear]);

  const handleYearChange = (event) => {
    setFinancialYear(event.target.value);
  };

  const handleSearch = () => {
    if (!financialYear) {
      setAlerts(true);
      setAlertsMess("Please select a financial year");
      return;
    }

    store.dispatch(
      get_balance_sheet_report({
        fy: financialYear?.toString(),
      })
    );
  };

  const formatCurrency = (value) => {
    if (!value || value === "0.00") return "₹0.00";
    return `₹${parseFloat(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const handleLiabilityChange = (key, value) => {
    setBalanceSheetData((prev) => ({
      ...prev,
      Liabilities: {
        ...prev.Liabilities,
        [key]: value,
      },
    }));
  };
  const handleAssestsChange = (key, value) => {
    setBalanceSheetData((prev) => ({
      ...prev,
      assets: {
        ...prev.assets,
        [key]: value,
      },
    }));
  };
  const handleUpdate = async () => {
    if (!financialYear) {
      setAlerts(true);
      setAlertsMess("Please select a financial year");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("action", "update");
      formData.append("ID", balanceSheetData?.Liabilities?.ID);
      formData.append("FYV", financialYear?.toString());
      formData.append("STATUS", 1);
      formData.append("REMARKS", "update");
      formData.append("MODIFIED_BY", user_id);
      formData.append("DETAIL_ID[0]", balanceSheetData?.Liabilities?.DETAIL_ID);
      formData.append("ULFR_AMT[0]", balanceSheetData?.Liabilities?.ULFR_AMT);
      formData.append("PROV_AMT[0]", balanceSheetData?.Liabilities?.PROV_AMT);
      formData.append("FYTL_AMT[0]", balanceSheetData?.Liabilities?.FYTL_AMT);

      formData.append(
        "CARS_AMT[0]",
        balanceSheetData?.assets?.TOTAL_LOAN_GIVEN
      );
      // formData.append("FYTL_AMT[0]", balanceSheetData?.assets?.FYTL_AMT);
      formData.append("CASD_AMT[0]", balanceSheetData?.assets?.CASD_AMT);
      formData.append("CALA_AMT[0]", balanceSheetData?.assets?.CALA_AMT);

      const responce = await axios.post(
        base_url + "financial_reports/balance_sheet.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const res = await responce.data;
      console.log(res);

      if (res?.success) {
        store.dispatch(
          get_balance_sheet_report({
            fy: financialYear,
          })
        );
        toast(res?.message);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {/* {loading && <Loader />} */}
      <PageHeading
        title={"Balance Sheet"}
        right={
          <>
            <BackButton />
          </>
        }
      />

      <div className="transactionMain">
        <div style={{ width: "180px" }}>
          <Dropdown
            label={"FINANCIAL YEAR"}
            value={financialYear}
            onChange={handleYearChange}
            options={
              <>
                <option value="">SELECT</option>
                {getFinancialYearOptions(profile_data?.CREATED_DATE)?.map(
                  (v, index) => (
                    <option key={index} value={v}>
                      {v}
                    </option>
                  )
                )}
              </>
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button title={"SEARCH"} onClick={handleSearch} />
        </div>
      </div>

      <div style={{ height: "20px" }}></div>

      {balance_sheet_loading ? (
        <PageLoading />
      ) : balanceSheetData?.Liabilities?.CAPITAL_ACCOUNT && financialYear ? (
        <div className="balance-sheet-container">
          {/* Liabilities and Assets Tables */}
          <p className="balance-sheet-heading">
            {profile_data?.name} Balance Sheet For FY {financialYear} As On{" "}
            {moment(new Date()).format("DD/MM/YYYY")}
          </p>
          <div className="balance-sheet-tables">
            {/* Liabilities Table */}
            <div className="balance-sheet-table">
              <div className="table-header">
                <div className="header-cell">LIABILITIES</div>
                <div className="header-cell">VALUE (₹)</div>
              </div>

              <div className="table-body">
                {/* Capital Account */}
                <div className="table-row">
                  <div className="cell-label">Capital Account</div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.Liabilities?.CAPITAL_ACCOUNT
                    )}
                  </div>
                </div>

                {/* Secured Loans */}
                <div className="table-row section-header">
                  <div className="cell-label">
                    Secured Loans (Closing Balance On 31st March)
                  </div>
                  <div className="cell-value"></div>
                </div>

                <div className="table-row sub-row">
                  <div className="cell-label indent">A/c - Hdfc OD</div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.Liabilities?.SANCTION_LIMIT_VALUE
                    )}
                  </div>
                </div>

                <div className="table-row sub-row">
                  <div className="cell-label indent">ICICI Term Loan</div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.Liabilities?.DISBURSED_AMOUNT_VALUE
                    )}
                  </div>
                </div>

                {/* Unsecured Loans */}
                <div className="table-row">
                  <div className="cell-label">
                    Unsecured Loans (From Payments Module)
                  </div>
                  <div className="cell-value">
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.Liabilities?.ULFR_AMT}
                      onChange={(e) =>
                        handleLiabilityChange("ULFR_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Sundry Creditors */}
                <div className="table-row">
                  <div className="cell-label">
                    Sundry Creditors (Payables To Vendors/OMC)
                  </div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.Liabilities?.TOTAL_PAYABLES_VALUE
                    )}
                  </div>
                </div>

                {/* Provisions */}
                <div className="table-row">
                  <div className="cell-label">
                    Provisions For Expenses - Salaries And Rents
                  </div>
                  <div className="cell-value">
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.Liabilities?.PROV_AMT}
                      onChange={(e) =>
                        handleLiabilityChange("PROV_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="table-row">
                  <div className="cell-label">Provision For Tax</div>
                  <div className="cell-value">
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.Liabilities?.FYTL_AMT}
                      onChange={(e) =>
                        handleLiabilityChange("FYTL_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Total */}
                {/* Spacer - SEPARATE element */}
                <div className="table-spacer"></div>
                <div className="table-row total-row">
                  <div className="cell-label">TOTAL LIABILITIES</div>
                  <div className="cell-value total">
                    {formatCurrency(balanceSheetData?.totals?.GRAND_TOTAL1)}
                  </div>
                </div>
              </div>
            </div>

            {/* Assets Table */}
            <div className="balance-sheet-table">
              <div className="table-header">
                <div className="header-cell">ASSETS</div>
                <div className="header-cell">VALUE (₹)</div>
              </div>

              <div className="table-body">
                {/* Fixed Assets */}
                <div className="table-row">
                  <div className="cell-label">
                    Fixed Assets (Residual Value After Depreciation)
                  </div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.assets?.TOTAL_ASSET_VALUE
                    )}
                  </div>
                </div>

                {/* Loans Given */}
                <div className="table-row">
                  <div className="cell-label">Loans Given</div>
                  <div className="cell-value">
                    {/* {formatCurrency(balanceSheetData?.assets?.TOTAL_LOAN_GIVEN)} */}
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.assets?.TOTAL_LOAN_GIVEN}
                      onChange={(e) =>
                        handleAssestsChange("TOTAL_LOAN_GIVEN", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Closing Stock */}
                <div className="table-row">
                  <div className="cell-label">Closing Stock</div>
                  <div className="cell-value">
                    {formatCurrency(balanceSheetData?.assets?.CACS_AMT)}
                  </div>
                </div>

                {/* Investments */}
                <div className="table-row">
                  <div className="cell-label">Investments</div>
                  <div className="cell-value">
                    {formatCurrency(balanceSheetData?.assets?.FANP_AMT)}
                  </div>
                </div>

                {/* Sundry Debtors */}
                <div className="table-row">
                  <div className="cell-label">
                    Sundry Debtors (Total Receivables From Customers)
                  </div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.assets?.TOTAL_RECEIVABLES_VALUE
                    )}
                  </div>
                </div>

                {/* Income Tax, TDS/TCS */}
                <div className="table-row">
                  <div className="cell-label">Income Tax</div>
                  <div className="cell-value">
                    {/* {formatCurrency(balanceSheetData?.assets?.FYTL_AMT)} */}
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.assets?.FYTL_AMT}
                      onChange={(e) =>
                        handleAssestsChange("FYTL_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="table-row">
                  <div className="cell-label">TDS/TCS</div>
                  <div className="cell-value">
                    {/* {formatCurrency(balanceSheetData?.assets?.CASD_AMT)} */}
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.assets?.CASD_AMT}
                      onChange={(e) =>
                        handleAssestsChange("CASD_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* GST ITC */}
                <div className="table-row">
                  <div className="cell-label">GST ITC</div>
                  <div className="cell-value">
                    {/* {formatCurrency(balanceSheetData?.assets?.CALA_AMT)} */}
                    <Input
                      placeholder={"Enter Amount"}
                      type={"number"}
                      value={balanceSheetData?.assets?.CALA_AMT}
                      onChange={(e) =>
                        handleAssestsChange("CALA_AMT", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* Account Balances */}
                <div className="table-row">
                  <div className="cell-label">
                    Account Balances (Current Accounts, Savings)
                  </div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.assets?.TOTAL_ACCOUNT_BALANCES
                    )}
                  </div>
                </div>

                {/* Cash Balance */}
                <div className="table-row">
                  <div className="cell-label">Cash Balance</div>
                  <div className="cell-value">
                    {formatCurrency(
                      balanceSheetData?.assets?.TOTAL_CASH_BALANCE
                    )}
                  </div>
                </div>
                <div className="table-spacer"></div>
                {/* Total */}
                <div className="table-row total-row">
                  <div className="cell-label">TOTAL ASSETS</div>
                  <div className="cell-value total">
                    {formatCurrency(balanceSheetData?.totals?.GRAND_TOTAL2)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button title={"Update"} onClick={handleUpdate} />
          </div>
          {/* Summary Section */}
          <div className="balance-sheet-summary">
            <div className="summary-card">
              <h3>Financial Summary</h3>
              <div className="summary-row">
                <span className="summary-label">Total Liabilities:</span>
                <span className="summary-value">
                  {formatCurrency(balanceSheetData?.totals?.GRAND_TOTAL1)}
                </span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Total Assets:</span>
                <span className="summary-value">
                  {formatCurrency(balanceSheetData?.totals?.GRAND_TOTAL2)}
                </span>
              </div>
              <div className="summary-row highlight">
                <span className="summary-label">Net Worth:</span>
                <span className="summary-value">
                  {formatCurrency(
                    (
                      parseFloat(balanceSheetData?.totals?.GRAND_TOTAL2 || 0) -
                      parseFloat(balanceSheetData?.totals?.GRAND_TOTAL1 || 0)
                    ).toFixed(2)
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="no-data-message">
          <p>
            Please select a financial year and click SEARCH to view the balance
            sheet.
          </p>
        </div>
      )}

      {alerts && (
        <SmallModal
          isOpen={alerts}
          setIsOpen={setAlerts}
          title={"Alert"}
          mess={alertsMess}
          okbtn={() => setAlerts(false)}
        />
      )}
    </div>
  );
};

export default BalanceSheet;
